import { EnumField } from "./EnumField";
import { Type, Validator } from "./Type";
import i18next from "i18next";

export const BooleanField = (...validators: Validator[]): Type => {
  const BooleanOptions = [
    { label: () => i18next.t("common:booleanEnum:yes", "YES"), value: 1 },
    { label: () => i18next.t("common:booleanEnum:no", "NO"), value: 0 }
  ];

  return EnumField(BooleanOptions, ...validators);
};
